"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportRangePermissionInfo = void 0;
var tslib_1 = require("tslib");
var table_1 = require("../../../../core/model/tables/main-structures/table");
var string_1 = require("@devexpress/utils/lib/utils/string");
var import_bookmark_info_core_1 = require("../bookmark/import-bookmark-info-core");
var ImportRangePermissionInfo = (function (_super) {
    tslib_1.__extends(ImportRangePermissionInfo, _super);
    function ImportRangePermissionInfo() {
        var _this = _super.call(this) || this;
        _this.columnFirst = -1;
        _this.columnLast = -1;
        return _this;
    }
    ImportRangePermissionInfo.prototype.validate = function (subDocument) {
        if (string_1.StringUtils.isNullOrEmpty(this.userName) && string_1.StringUtils.isNullOrEmpty(this.group))
            return false;
        if (this.end - this.start < 0)
            return false;
        if (this.columnFirst >= 0 || this.columnLast >= 0)
            if (this.columnFirst < 0 || this.columnLast < 0 || table_1.Table == null)
                return false;
        return _super.prototype.validate.call(this, subDocument);
    };
    return ImportRangePermissionInfo;
}(import_bookmark_info_core_1.ImportBookmarkInfoCore));
exports.ImportRangePermissionInfo = ImportRangePermissionInfo;
